import { useMutation } from "@tanstack/react-query";
import { sendThankYou } from "@/api/redemption";

/**
 * Save the recipient's thank-you note to the sender (RFW-9). A plain mutation — the
 * screen advances locally on success, and the note write doesn't change the
 * gift-context query, so there's nothing to invalidate.
 */
export function useSendThankYou() {
  return useMutation<void, Error, { token: string; note: string; contactId?: number }>({
    mutationFn: ({ token, note, contactId }) => sendThankYou(token, note, contactId),
  });
}
